import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PpbApiService } from '../../ppb/shared/services/ppb-api.service';
import { ApiVersionsModel } from './api-versions.model';

export function configProviderFactory(provider: ConfigurationService): () => Promise<boolean> {
  return () => provider.load();
}

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private apiVersion = new BehaviorSubject<ApiVersionsModel>(null);
  // tslint:disable-next-line
  apiVersion$ = this.apiVersion.asObservable();

  constructor(
    private api: PpbApiService
  ) {}


  fetchApiVersions(): Observable<ApiVersionsModel> {
    return this.api.getPublic<ApiVersionsModel>('/api/v1/version')
  }

  load(): Promise<boolean> {
    return new Promise((resolve, _reject) => {
      this.fetchApiVersions()
        .subscribe(
          (response: ApiVersionsModel) => {
            this.apiVersion.next(response);
            resolve(true);
          });
    })
  }
}
